import { useState } from 'react';

export const useTableSort = <T extends Record<string, any>>(initialData: T[]) => {
  const [sortDirectionMap, setSortDirectionMap] = useState<{ [key: string]: 'asc' | 'desc' }>({});
  const [sortedData, setSortedData] = useState(initialData);

  const sortByKey = (key: string) => {
    const currentDirection = sortDirectionMap[key] || 'asc';
    const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';

    setSortDirectionMap((prev) => ({ ...prev, [key]: newDirection }));

    const sorted = [...sortedData].sort((a, b) => {
      if (newDirection === 'asc') {
        return a[key] > b[key] ? 1 : -1;
      } else {
        return a[key] < b[key] ? 1 : -1;
      }
    });

    setSortedData(sorted);
  };

  return { sortedData, setSortedData, sortByKey, sortDirectionMap };
};
